import { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import styles from './SelectedDateTrips.module.scss';
import { Trip } from '../../../../../types/trip.types';
import { formatDateToLocal, formatDateShort, isTripActive } from '../../../../../utils/dateUtils';
import TripCard from '../TripCard';

interface SelectedDateTripsProps {
  trips?: Trip[];
  selectedDate: Date;
  onDeleteTrip?: (tripId: number) => void;
}

const SelectedDateTrips: FC<SelectedDateTripsProps> = ({ trips = [], selectedDate, onDeleteTrip }) => {
  const tripStartDates = useMemo(() => {
    const datesWithTrips = new Map<string, Trip[]>();

    trips.forEach(trip => {
      const startDate = new Date(trip.start_date);
      const dateKey = formatDateToLocal(startDate);

      if (!datesWithTrips.has(dateKey)) {
        datesWithTrips.set(dateKey, []);
      }
      datesWithTrips.get(dateKey)!.push(trip);
    });

    return datesWithTrips;
  }, [trips]);

  const checkIfTripActive = (trip: Trip) => {
    return isTripActive(trip.start_date, trip.end_date);
  };

  const selectedDateTrips = tripStartDates.get(formatDateToLocal(selectedDate)) || [];

  return (
    <Box className={styles.selectedDateTrips}>
      <Box className={styles.sectionTitle}>
        <Typography
          variant="h9Semibold"
          className={styles.titleText}
        >
          Upcoming
        </Typography>
        <Typography
          variant="h12"
          className={styles.titleDate}
        >
          • {formatDateShort(selectedDate)}
        </Typography>
      </Box>

      {selectedDateTrips.length > 0 ? (
        <Box className={styles.tripsList}>
          {selectedDateTrips.map(trip => (
            <TripCard
              key={trip.id}
              trip={trip}
              variant="compact"
              isActive={checkIfTripActive(trip)}
              onDelete={onDeleteTrip}
            />
          ))}
        </Box>
      ) : (
        <Box className={styles.emptyState}>
          <Typography variant="h10">No trips starting this date</Typography>
          <Typography
            variant="h12"
            sx={{ color: '#5E6A81' }}
          >
            Select a date with trip starts or create a new one
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default SelectedDateTrips;
